



























































































































import Vue from 'vue';
import Component from 'vue-class-component';
import {
	mapActions, mapGetters, mapMutations, mapState,
} from 'vuex';
import ReservationQuote from '@/components/ReservationQuote.vue';
import Quote from '@/models/Quote';
import ReservationStep from '@/types/reservationStep';
import portalMixin from '@/mixins/portalMixin';
import Service from '@/services/Service';
import MarkdownText from '@/components/ui/MarkdownText.vue';

const Setup = Vue.extend({
	name: 'ReservationQuoteList',
	inject: ['$validator'],
	components: {
		ReservationQuote,
		MarkdownText,
	},
	computed: {
		...mapGetters(['isLoggedIn']),
		...mapState(['formErrors', 'isLoading']),
		...mapGetters('location', ['settings']),
		...mapState('reservation', ['noQuotes', 'quotes', 'selectedQuote', 'initialQuote']),
		...mapGetters('reservation', ['hasReservation']),
	},
	methods: {
		...mapMutations('reservation', ['resetFpp', 'setQuote', 'setStep', 'setRewards', 'setInitialQuote']),
		...mapActions('reservation', ['getQuotes', 'getReservationQuotes']),
	},
});

@Component
export default class QuoteList extends Setup {
	loadingReward: boolean = false;
	loadQuote: boolean = false;
	continueQuote: boolean = false;
	servicesRequested: boolean = false;
	rewardCard: string = '';
	currentQuote: Quote = new Quote();
	requireServiesQuote: Quote = new Quote();
	showError: boolean = false;

	// Vuex
	public isLoading!: boolean;
	public isLoggedIn!: boolean;
	public noQuotes!: boolean;
	public quotes!: Quote[];
	public resetFpp!: () => void;
	public setQuote!: (quote: Quote) => void;
	public setStep!: (payload: ReservationStep) => void;
	public settings!: Locations.Settings;
	public formErrors!: [];
	public getQuotes!: (payload?: any) => Promise<any>;
	public getReservationQuotes!: () => Promise<Quote[]>;

	public get isBlackout(): any[] {
		return this.formErrors.filter((error: any) => error.field === 'blackout');
	}

	public get displayText(): string {
		if (this.settings.custom_validation_message) {
			return this.settings.custom_validation_message;
		}

		if (window.location.href.indexOf('park2go') >= 0) {
			return 'Please enter your Automobile Association card number:';
		}

		return 'Please enter your ID:';
	}

	public async created() {
		if (!this.quotes.length && this.isBlackout.length) {
			try {
				await this.getQuotes();
			} catch (error) {
				// Error getting quotes.
			}
		}
	}

	public mounted() {
		if (this.settings.request_login_after_quotes && !this.isLoggedIn && this.$store.getters['reservation/step'] === 1) {
			this.$modal.show('hidden-login-modal');
		}
		this.$modal.hide('services-requested-popup');

		if (this.initialQuote >= 0 && this.quotes.length && this.initialQuote < this.quotes.length) {
			this.onSelectQuote(this.quotes[this.initialQuote]);
			this.setInitialQuote(-1);
		}
	}

	public onSelectQuote(quote: Quote) {
		if (quote.details.require_services && !this.continueQuote) {
			this.loadQuote = false;
			this.requireServiesQuote = quote;
			this.$modal.show('services-requested-popup');
		}

		if (!quote.details.require_services || this.continueQuote) {
			if (quote.requires_validation) {
				this.$modal.show('validateRate');
				this.currentQuote = quote;
				this.showError = false;
			} else {
				this.resetFpp();
				this.setQuote(quote);
				this.$store.commit('clearErrors');
				this.setStep(ReservationStep.Customer);

				// Quote selected so let's get the services.
				this.$store.dispatch('reservation/getServices');
			}
		}
	}

	public validationSubmit() {
		this.checkRewardValidation();
		this.loadingReward = true;
	}

	public servicesRequestedPopupSubmit() {
		this.$modal.hide('services-requested-popup');
		this.continueQuote = true;
		this.loadQuote = false;
		this.onSelectQuote(this.requireServiesQuote);
	}

	public cancelValidationRate() {
		this.$modal.hide('validateRate');
		this.loadingReward = false;
	}

	public cancelServicesRequestedPopup() {
		this.$modal.hide('services-requested-popup');
		this.continueQuote = false;
		this.loadQuote = false;
		this.requireServiesQuote = new Quote();
	}

	public validation_submit_text() {
		if (this.currentQuote.validation_checkbox) {
			return 'Accept';
		}

		return 'Submit';
	}

	public async checkRewardValidation() {
		if (this.currentQuote.validation_checkbox) {
			this.loadingReward = false;
			this.$modal.hide('validateRate');
			this.setQuote(this.currentQuote);
			this.$store.commit('clearErrors');
			this.setStep(ReservationStep.Customer);

			// Quote selected so let's get the services.
			this.$store.dispatch('reservation/getServices');
			return true;
		}
		let results = null;
		try {
			results = await Service.post('checkRewardCard', { card: this.rewardCard });
		} catch (e) {
			this.loadingReward = false;
			this.showError = true;
			return false;
		}

		this.loadingReward = false;
		this.$modal.hide('validateRate');
		this.resetFpp();
		this.setQuote(this.currentQuote);
		this.setRewards(results);
		this.$store.commit('clearErrors');
		this.setStep(ReservationStep.Customer);

		// Quote selected so let's get the services.
		this.$store.dispatch('reservation/getServices');
		return true;
	}
}
